import {useNavigate} from "react-router-dom";
// import Header from "../Header";
import { useEffect, useRef, useState } from "react";
import { useSelector , useDispatch} from "react-redux";
import { ToolsList } from "@/store/actions";
import Avatar, { genConfig } from 'react-nice-avatar';
import { IconPlus, IconDots, IconChevronRight, IconPencil } from '@tabler/icons-react';
import { AppDispatch } from "@/store";
import chatflows from "@/api/chatflows";
import useApi from "@/hooks/useApi";

export default function Tool() {
	const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();
    const { tools } = useSelector((state: any) => state.tools);
	const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);

    useEffect(() => {
        dispatch(ToolsList());
    }, [dispatch]);

	const handleToggle = (id: string) => {
        setOpenDropdownId((prevId) => (prevId === id ? null : id));
    };

    const dropdownRef = useRef<HTMLDivElement>(null);
    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setOpenDropdownId(null);
        }
    };


    const DeleteChatFlow: any = useApi(chatflows.deleteChatflow)

    useEffect(() => {
        if (openDropdownId !== null) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDropdownId]);

    const UseTools = (data: any) =>{
      navigate(`/useTools/${data?.id}`,{ state: { tools: data } });
    }

    const handleDelete = (id: any) => {
      DeleteChatFlow.request(id).then(() => {
        dispatch(ToolsList());
      });
    }

	return (
		<>
			<div className="container">
        <div className="flex w-full flex-row gap-6 items-center justify-between md:p-4">
          <h2 className="text-gray-900 text-3xl mt-4 font-bold mb-2">Tools</h2>

    {/* Uncomment and update if needed */}
    {/* 
    <div className="flex flex-col">
      <button className="hover:bg-gray-200 text-gray-500 font-bold py-1 px-2 rounded-md inline-flex items-center border border-gray-200 bg-white focus:border-blue-500 focus:border-2 mb-2">
        <span>My Tools</span>
      </button>
      <button className="hover:bg-gray-200 text-gray-500 font-bold py-1 px-2 rounded-md inline-flex items-center border border-gray-200 bg-white focus:border-blue-500 focus:border-2 mb-2">
        <span>Market Place</span>
      </button>
    </div>
    */}

    <button
      className="hover:bg-gray-200 text-gray-500 font-bold py-1 px-2 rounded-md inline-flex items-center border border-gray-200 bg-white focus:border-blue-500 focus:border-2"
      onClick={() => navigate('/addtool')}
    >
      <IconPlus />
      <span>New</span>
    </button>
  </div>

  <div className="w-full md:mt-8 md:p-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    {tools?.map((data: any, index: number) => {
      const tool = JSON.parse(data.flowData);
      const config = genConfig(data?.tool_name);

      return (
        <div
          key={index}
          className="card card-hover shadow-sm border border-gray-200 bg-white rounded-lg relative p-4 group"
        >
          <div className="edit-button absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <button
              className="hover:bg-gray-200 text-gray-500 font-bold py-1 px-2 rounded-md inline-flex items-center bg-white focus:border-blue-500 focus:border-2"
              onClick={(e) => {
				e.stopPropagation();
				navigate(`/addtool/${data?.id}`);
     }}
            >
              <IconPencil size={16} />
            </button>
          </div>

          <div className="card-body">
            <div className="flex justify-between items-center">
              <h2 className="card-title inline-flex items-center gap-2">
                <Avatar style={{ width: '3rem', height: '2.9rem' }} {...config} />
                <span className="agent-title">{data?.tool_name}</span>
				
              </h2>

			
            </div>
			<p className="text-sm text-muted-foreground line-clamp-2">
                                {tool?.overview?.description || '...'}
                            </p>
							<div className="flex w-full flex-row gap-6 items-center justify-between mt-4">
                                <div className="inline-block text-left">
                                <div
                                    className="border border-gray-300 bg-white rounded-lg md:py-1 md:px-2 cursor-pointer hover:bg-gray-300"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    handleToggle(data.id);
                                    }}
                                >
                                    <IconDots size={20} />
                                </div>
                                {openDropdownId === data.id && (
                                    <div className="card border rounded-lg shadow-lg p-2 z-50 flex flex-col absolute bg-white" ref={dropdownRef}>
                                    <button
                                        className="text-sm rounded-lg px-4 py-2 hover:bg-gray-200 focus:outline-none"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        // Handle Duplicate action
                                        }}
                                        
                                    >
                                        Duplicate
                                    </button>
                                    <button
                                        className="text-sm rounded-lg px-4 py-2 hover:bg-gray-200 focus:outline-none"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        // Handle Delete action
                                        handleDelete(data?.id)
                                        }}
                                    >
                                        Delete
                                    </button>
                                    </div>
                                )}
                                </div>
                                <div className="flex items-end gap-2">
									<button
										className="inline-flex items-center md:py-1 md:px-2 rounded-lg border border-gray-300 justify-end bg-black text-white"
										onClick={(e) => { 
											e.stopPropagation();
                      UseTools(data)
										}}
									>
										<span className="pe-1 pb-0.5">Use</span>
										<IconChevronRight size={16} />
									</button>
								</div>

                            </div>
          </div>
        </div>
      );
    })}
  </div>
</div>

		</>
	)
}
